




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobStatus from '@/models/Jobs/JobStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';

@Component({
  name: 'JobStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	jobStatus: JobStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;

	get textColor() {
		let color = "black--text";
		switch (this.jobStatus) {
			case JobStatus.Open:
				color = "green--text"
				break;	
			case JobStatus.Closed:
				color = "red--text"	
				break;	
			default:
				color = "black-text"
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.jobStatus) {
			case JobStatus.Open:
				text = "OPEN";
				break;
			case JobStatus.Closed:
				text = "CLOSED"
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.Grid:
				classes.push("overline");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
